module.exports = __webpack_public_path__ + "static/media/Desktop_Summary_1.036947dd.png";